import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20panoramic%20illustration%20of%20a%20grand%20fantasy%20library%20filled%20with%20floating%20books%20and%20glowing%20magical%20pages%2C%20warm%20golden%20and%20amber%20lighting%2C%20cozy%20reading%20atmosphere%2C%20soft%20bokeh%20effects%2C%20dreamy%20and%20inviting%20mood%2C%20horizontal%20composition%2C%20cinematic%20quality%2C%20rich%20detail&width=1600&height=600&seq=cta-home-01&orientation=landscape"
        alt="韩漫之家阅读空间"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/50"></div>

      <div className="absolute inset-0 z-10 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto relative h-full">
            <div className="absolute top-1/4 left-0 md:left-4">
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight">
                开启你的<br />韩漫之旅
              </h2>
            </div>

            <div className="absolute bottom-1/4 left-0 md:left-4">
              <Link
                to="/category/romance"
                className="inline-flex items-center gap-3 bg-background-50 text-foreground-950 px-6 py-3 md:px-8 md:py-4 rounded-full text-base md:text-lg font-semibold whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
              >
                免费阅读
                <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>

            <div className="absolute bottom-1/4 right-0 md:right-4 max-w-xs">
              <p className="text-base md:text-lg text-background-50/80 leading-relaxed font-light">
                海量韩国漫画免费阅读<br />
                随时随地，畅享阅读乐趣
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}